import { baseWebUrl, baseAPIUrl, httpPostHandleResponse, initializeJqueryValidator, sweetAlert, AlertType, getHtml_HandleBar, isNullOrEmpty } from "../utils/common"
import http, { GetToken } from "../services/httpService";
import moment = require("moment");

class Contants {
    readonly controller: string = baseAPIUrl() ? `${baseAPIUrl()}/Authentication` : '/Authentication';
    readonly controllerUser: string = baseAPIUrl() ? `${baseAPIUrl()}/User` : '/User';
    readonly notificationController: string = baseAPIUrl() ? `${baseAPIUrl()}/Notification` : '/Notification';
    readonly mLoginUser: string = "#m-LoginUser";
    readonly wLoginUser: string = "#w-LoginUser";
    readonly mLoginUserFirstChar: string = "#m-LoginUserFirstChar";
    readonly wLoginUserFirstChar: string = "#w-LoginUserFirstChar";
    readonly btnPasswordChange: string = "#btnPasswordChange";
    readonly txtNewPassword: string = "#txtNewPassword";
    readonly txtNewCPassword: string = "#txtNewCPassword";
    readonly txtOldPassword: string = "#txtOldPassword";
    readonly voucherPrefix: string = ".VoucherPrefix";

}
class AdminLayout {
    constants: Contants = new Contants();
    $mLoginUser: JQuery<HTMLElement>;
    $wLoginUser: JQuery<HTMLElement>;
    $mLoginUserFirstChar: JQuery<HTMLElement>;
    $wLoginUserFirstChar: JQuery<HTMLElement>;
    $btnPasswordChange: JQuery<HTMLElement>;
    $txtNewPassword: JQuery<HTMLElement>;
    $txtNewCPassword: JQuery<HTMLElement>;
    $txtOldPassword: JQuery<HTMLElement>;

    constructor() {
        this.Init();
        this.$mLoginUser = $(this.constants.mLoginUser);
        this.$wLoginUser = $(this.constants.wLoginUser);
        this.$mLoginUserFirstChar = $(this.constants.mLoginUserFirstChar);
        this.$wLoginUserFirstChar = $(this.constants.wLoginUserFirstChar);
        this.$btnPasswordChange = $(this.constants.btnPasswordChange);
        this.$txtNewPassword = $(this.constants.txtNewPassword);
        this.$txtNewCPassword = $(this.constants.txtNewCPassword);
        this.$txtOldPassword = $(this.constants.txtOldPassword);
        this.$btnPasswordChange.on('click', this.changePassword);
        this.setUser();
    }

    private Init = async () => {
        this.loadLogo();
        this.generateMenu();
        this.GetDashboardNotification();
        const rules = {
            txtOldPassword: {
                required: true
            },
            txtNewPassword: {
                required: true,
                passwordComplexity: true
            },
            txtNewCPassword: {
                equalTo: "#txtNewPassword"
            }
        };

        initializeJqueryValidator("#axon_form_admin", rules);
        //this.IsUserExist();

        $('#btnSignOut').click(async () => {
            const redirectUrl = localStorage.getItem("RedirectionURL");
            GetToken();
            const response = await http.post(this.constants.controller + "/Logout/" + redirectUrl);
            const data = httpPostHandleResponse(response);
            if (data) {
                localStorage.removeItem('SecurityToken');
                localStorage.removeItem('UserData');
                localStorage.removeItem("SetupTime");
                localStorage.removeItem("UserAddress");
                localStorage.removeItem("Configuration");
                localStorage.removeItem("Menu");
                localStorage.removeItem('RedirectionURL');
                window.location.href = data;
            }
        });

        $('#btnOpenModal').click(() => {
            this.$txtOldPassword.val('');
            this.$txtNewPassword.val('');
            this.$txtNewCPassword.val('');
        });

        $(document).on('click', this.constants.voucherPrefix, (e: JQueryEventObject) => {
            const prefix = $(e.currentTarget).data("prefix");
            localStorage.setItem("Prefix", prefix);
        });
        
        $(document).on('click', '#contDashboardNotificationContainer .kt-notification__item', this.clickNotification);
    }
    private clickNotification = async (event: JQueryEventObject) => {
        const clickedObj = $(event.currentTarget),
            heading = clickedObj.data('heading'),
            description = clickedObj.data('description');

        $('#kt_Dashboard_Notification_Title').html(heading);
        $('#kt_Dashboard_Notification_Description').html(description);
        $('#kt_Dashboard_Notification').modal('show');
    }
    private changePassword = async () => {
        if ($("#axon_form_admin").valid()) {
            const userData = JSON.parse(localStorage.getItem('UserData'));
            const obj = {
                Id: userData.Id,
                OldPassword: this.$txtOldPassword.val(),
                NewPassword: this.$txtNewPassword.val()

            };
            GetToken();
            const response = await http.post(this.constants.controllerUser + "/ChangePassword", obj);
            const data = httpPostHandleResponse(response);
            if (data.result == true) {
                sweetAlert(AlertType.Success, "Password Changed", "Your password has been changed.")
                const modal: any = $('#kt_modal_6');
                modal.modal('hide');
            }
            else {
                sweetAlert(AlertType.Error, "Invalid Password", "Old password not matched.")
            }
        }
    }
    private setUser = () => {
        const userData = JSON.parse(localStorage.getItem("UserData"));
        this.$mLoginUser.html(userData.Name);
        this.$wLoginUser.html(userData.Name);
        this.$mLoginUserFirstChar.html(String(userData.Name).charAt(0).toUpperCase());
        this.$wLoginUserFirstChar.html(String(userData.Name).charAt(0).toUpperCase());
    }
    private loadLogo = () => {
        const userData = JSON.parse(localStorage.getItem("UserData")),
            logoPath = baseWebUrl() + userData.PortalLogoPath;

        if (!isNullOrEmpty(userData.PortalLogoPath)) {
            $('#dashboardLogo').removeClass('d-none').prop('src', logoPath);
            $('#dashboardLogoMobile').removeClass('d-none').prop('src', logoPath);
        }

        if (!isNullOrEmpty(userData.PortalName)) {
            $('#lblPortalName').html(userData.PortalName);
        }

        const userPermissions: string[] = userData.Permissions || [];
        const hasAdminPermission = userPermissions.indexOf('View_AdminDashboard') !== -1;
        const logoHref = baseWebUrl() + (hasAdminPermission ? '/Admin/Dashboard/' : '/employee/Dashboard/');
        $('#dashboardLogo').closest('a').attr('href', logoHref);
        $('#dashboardLogoMobile').closest('a').attr('href', logoHref);
    }
    private generateMenu = () => {
        const menuData = JSON.parse(localStorage.getItem("Menu")),
            Menu: any = {};

        if (menuData !== null && menuData.length > 0) {
            const l = menuData.length;

            let i = 0;

            for (i; i < l; i++) {
                let currObj: any = menuData[i];

                currObj.Id = currObj.Parent.trim().replaceAll(' ', '') + "_" + currObj.Title.trim().replaceAll(' ', '');

                if (Menu.hasOwnProperty(currObj.Parent)) {
                    if (currObj.SubParent == null || currObj.SubParent == undefined || currObj.SubParent == '') {
                        Menu[currObj.Parent].push(currObj);
                    } else {
                        currObj.SubId = currObj.Parent.trim().replaceAll(' ', '') + "_" + currObj.SubParent.trim().replaceAll(' ', ''); + "_" + currObj.Title.trim().replaceAll(' ', '');

                        if (Menu[currObj.Parent][currObj.SubParent] == null || Menu[currObj.Parent][currObj.SubParent] == undefined) {
                            Menu[currObj.Parent][currObj.SubParent] = { IsParentMenu: true, Menus: [currObj] };
                        } else {
                            Menu[currObj.Parent][currObj.SubParent].Menus.push(currObj);
                        }
                    }
                } else {
                    if (currObj.SubParent == null || currObj.SubParent == undefined || currObj.SubParent == '') {
                        Menu[currObj.Parent] = [currObj];
                    } else {
                        let obj: any = {};
                        currObj.IsParentMenu = true;
                        currObj.SubId = currObj.Parent.trim().replaceAll(' ', '') + "_" + currObj.SubParent.trim().replaceAll(' ', ''); + "_" + currObj.Title.trim().replaceAll(' ', '');

                        obj[currObj.SubParent] = { IsParentMenu: true, Menus: [currObj] };

                        Menu[currObj.Parent] = obj;
                    }
                }
            }

            const data = { Menu: Menu },
                menuHtml = getHtml_HandleBar("#tmplMenuItem", data);

            $('#menuContainer').append(menuHtml);
        }
    }
    private GetDashboardNotification = async () => {
        GetToken();

        const response = await http.get(this.constants.notificationController + "/GetDashboardNotifications");
        let data = httpPostHandleResponse(response);

        if (data.length > 0) {

            let i = 0,
                l = data.length;

            if (l > 99) {
                $('#contDashboardNotificationCount').html('99+').removeClass('d-none');
            } else {
                $('#contDashboardNotificationCount').html(l).removeClass('d-none');
            }

            for (i; i < l; i++) {
                let nDate = new Date(data[i].ModifiedOn),
                    today = new Date();;

                if (nDate.getFullYear() < 2020) {
                    nDate = new Date(data[i].CreatedOn);
                }

                let timeString = "",
                    nDatem = moment(nDate),
                    todaym = moment(today);

                if (todaym.diff(nDatem, 'years') == 1) {
                    timeString = (todaym.diff(nDatem, 'years')).toString() + ' year ago'
                } else if (todaym.diff(nDatem, 'years') > 1) {
                    timeString = (todaym.diff(nDatem, 'years')).toString() + ' years ago'
                } else if (todaym.diff(nDatem, 'months') == 1) {
                    timeString = (todaym.diff(nDatem, 'months')).toString() + ' month ago'
                } else if (todaym.diff(nDatem, 'months') > 1) {
                    timeString = (todaym.diff(nDatem, 'months')).toString() + ' months ago'
                } else if (todaym.diff(nDatem, 'days') == 1) {
                    timeString = (todaym.diff(nDatem, 'days')).toString() + ' day ago'
                } else if (todaym.diff(nDatem, 'days') > 1) {
                    timeString = (todaym.diff(nDatem, 'days')).toString() + ' days ago'
                } else if (todaym.diff(nDatem, 'hours') == 1) {
                    timeString = (todaym.diff(nDatem, 'hours')).toString() + ' hour ago'
                } else if (todaym.diff(nDatem, 'hours') > 1) {
                    timeString = (todaym.diff(nDatem, 'hours')).toString() + ' hours ago'
                } else if (todaym.diff(nDatem, 'minutes') == 1) {
                    timeString = (todaym.diff(nDatem, 'minutes')).toString() + ' minute ago'
                } else if (todaym.diff(nDatem, 'minutes') > 1) {
                    timeString = (todaym.diff(nDatem, 'minutes')).toString() + ' minutes ago'
                } else if (todaym.diff(nDatem, 'seconds') == 1) {
                    timeString = (todaym.diff(nDatem, 'seconds')).toString() + ' second ago'
                } else if (todaym.diff(nDatem, 'seconds') > 1) {
                    timeString = (todaym.diff(nDatem, 'seconds')).toString() + ' seconds ago'
                }

                data[i].Hours = timeString;
            }

            const html = getHtml_HandleBar('#dashboardNotificationTemplate', { data: data });
            $('#contDashboardNotificationContainer').empty().append(html);
        } else {
            $('#contDashboardNotificationCount').html('0').addClass('d-none');
            let data1 = [{ Heading: 'No Notifications Found!' }]

            const html = getHtml_HandleBar('#dashboardNoNotificationTemplate', { data: data1 });
            $('#contDashboardNotificationContainer').empty().append(html);
        }
    }
}


$(() => new AdminLayout());